import React from 'react';
import PropTypes from 'prop-types';

import ButtonCollapse from 'components/Widgets/ButtonCollapse';

export default function Section({ id, title, collection }) {
  const alwaysShow = 6;

  if (collection.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <h6 className="mb-2">
        {title}
      </h6>

      <ul className="list-unstyled mb-0 fw-light">
        {collection.slice(0, alwaysShow).map((item) => (
          <li key={item} className="mb-1 small">
            {item}
          </li>
        ))}

        {collection.length > alwaysShow && (
          <div className={`${id} collapse`}>
            {collection.slice(alwaysShow).map((item) => (
              <li key={item} className="mb-1 small">
                {item}
              </li>
            ))}
          </div>
        )}
      </ul>

      {collection.length > alwaysShow && (
        <ButtonCollapse
          target={`.${id}`}
          controls={id}
          className="btn-sm text-gray-900 text-decoration-none fw-semibold"
        />
      )}
    </div>
  );
}

Section.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  collection: PropTypes.arrayOf(PropTypes.string).isRequired,
};
